import { BodyText, ItemWrapper, Section, Title } from '../List/List.styles';
import { DefaultUISettings, Service, TCFUISettings, UI_VARIANT } from '@usercentrics/cmp-browser-sdk';
import { FunctionalComponent, h } from 'preact';
import { Suspense, lazy, useEffect, useRef, useState } from 'preact/compat';
import SubServicePlaceholder from './SubServicePlaceholder';
import initializeDataReader from '../../helpers/suspend';
import { useSettingsContext } from '../../contexts/SettingsContext';
import { useUiContext } from '../../contexts/UiContext';

interface Props {
  fetchSubServices: () => Promise<Service[]>;
  onOpenSubServiceDetail: (subService: Service) => void;
  onToggleExpandable?: () => void;
  size: number;
}

const SubServicesList = lazy(() => import('./SubServicesList'));

const SubServices: FunctionalComponent<Props> = ({
  fetchSubServices,
  onOpenSubServiceDetail,
  onToggleExpandable,
  size,
}) => {
  const subServiceRef = useRef<HTMLDivElement>(null);
  const [subServicesReader] = useState(() => initializeDataReader(fetchSubServices));
  const { uiVariant, scrollToSubServices, setScrollToSubServices } = useUiContext();
  const { settings } = useSettingsContext();

  useEffect(() => {
    const ref = subServiceRef.current;

    if (scrollToSubServices && ref) {
      ref.scrollIntoView(true);
      setScrollToSubServices(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [scrollToSubServices, subServiceRef]);

  const labels =
    uiVariant === UI_VARIANT.TCF
      ? (settings.ui as TCFUISettings).labels.nonTCFLabels.general
      : (settings.ui as DefaultUISettings).labels.general;

  return (
    <Section ref={subServiceRef}>
      <Title>{labels.subservices}</Title>
      <BodyText>{labels.subservicesDescription}</BodyText>
      <ItemWrapper>
        <Suspense fallback={<SubServicePlaceholder size={size} />}>
          <SubServicesList
            subServicesReader={subServicesReader}
            onOpenSubServiceDetail={onOpenSubServiceDetail}
            onToggleExpandable={onToggleExpandable}
          />
        </Suspense>
      </ItemWrapper>
    </Section>
  );
};

export default SubServices;
